<template>
  <router-view />
</template>

<style>
@import "./assets/style/reset.css";

body {
  font-family: "Rubik", sans-serif;
}
</style>
